import { Col, Icon, Row } from "@visa/vds"
import { DateHelper } from "_helpers/DateHelper"
import { FileHelper } from "_helpers/FileHelper"
import { GlobalAlertContext } from "context/GlobalAlertContext"
import React, { useContext } from "react"
import { trackPromise } from "react-promise-tracker"
import { ceritificationPackageService } from "services/certification.certificationPackage"

const CertificationPackageCompletedInformation = ({ certificationPackageCompletedInformation, bid, packageId, }) => {
    const alertContext = useContext(GlobalAlertContext);

    const downloadComplianceLetter = () => {
        trackPromise(
            ceritificationPackageService.DownloadComplianceLetter(bid, certificationPackageCompletedInformation.compApprovalId, packageId)
                .then((result) => {
                    FileHelper.DownloadFile(result);
                })
                .catch(error => alertContext.setErrorMessage("Unable to download Compliance Letter. Please try again later."))
        );
    }
    return (
        <>
            <Row>
                <Col>
                    <span className="font-weight-bold">Visa Secure Compliance Letter</span>
                    <br />
                    <span className="cursor-pointer" ><a onClick={() => downloadComplianceLetter()}>{certificationPackageCompletedInformation.compApprovalId}</a></span>
                </Col>
                <Col>
                    <span className="font-weight-bold">Visa Expiry Date</span>
                    <br />
                    <span>{DateHelper.ToFormattedDate(certificationPackageCompletedInformation.compExpiryDate)}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="font-weight-bold">Testing Start Date</span>
                    <br />
                    <span>{DateHelper.ToFormattedDate(certificationPackageCompletedInformation.testingStartDate)}</span>
                </Col>
                <Col>
                    <span className="font-weight-bold">Testing Completion Date</span>
                    <br />
                    <span>{DateHelper.ToFormattedDate(certificationPackageCompletedInformation.testingEndDate)}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="font-weight-bold">Testing Region(s)</span>
                    <br />
                    <span>{certificationPackageCompletedInformation.testingRegions}</span>
                </Col>
                <Col>
                    <span className="font-weight-bold">Product Name and Version</span>
                    <br />
                    <span>{certificationPackageCompletedInformation.productNameAndVersion}</span>
                </Col>
            </Row>
            <Row>
                <Col>
                    <span className="font-weight-bold">Test Cases Supported</span>
                    <br />
                    <span>{certificationPackageCompletedInformation.testCasesSupported}</span>
                </Col>
                <Col />
            </Row>
            <Row>
                <Col>
                    <span className="font-weight-bold">Do you wish to be listed on Visa’s Public Approved EMV 3DS Products List?</span>
                    <a className="text-decoration-none" href="https://www.visasecureservices.com/ApprovedProducts" target="_blank" rel="noopener noreferrer">
                        <span className="certification-package-completed-information-update-text cursor-pointer">View List</span>
                        <span className="certification-package-completed-information-update-icon cursor-pointer"><Icon name="maximize" resolution="tiny" aria-label="maximize" /></span>
                    </a>
                    <br />
                    <span>{certificationPackageCompletedInformation.publicOptIn ? "Yes" : "No"}</span>

                </Col>
                <Col>
                    {
                        certificationPackageCompletedInformation.publicOptIn &&
                        <>
                            <span className="font-weight-bold">Public Email Contact to be listed</span>
                            <br />
                            <span>{certificationPackageCompletedInformation.publicContactEmail}</span>
                        </>
                    }

                </Col>
            </Row>
        </>
    )
}

export default CertificationPackageCompletedInformation